import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _RecordBudget } from "../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { Modal } from "../../../../theme/Component/Modal";
import { BasicTable } from "../../../../theme/Component/BasicTable";



interface Props {
    adquisitionContract: any;
    paymentDate: any;
    onChange: Function;
    label?: string;
}

export const SelectorRPBudgetContract = ({ onChange, label, adquisitionContract, paymentDate }: Props) => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_RecordBudget);
    const [valor, setValor] = useState<string>();
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (adquisitionContract.IDAdquisitionContract && paymentDate) {
            getLista();
        }
    }, [adquisitionContract, paymentDate])

    const getLista = () => {
        instance.getBudgetRecordForAdquisitionContract(adquisitionContract.IDAdquisitionContract, adquisitionContract.AdquisitionContractDate, paymentDate).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDDocument', visible: true },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Consecutivo Ext', property: 'ExternalReference', visible: true },
        { title: 'Fecha del Documento', property: 'DocumentDate', visible: true },
        { title: 'Estado', property: 'DocumentStateName', visible: true },
    ]

    const getItem = () => {
        if (bean.IDDocument) {
            setModal({ ...modal, "view": false })
            setValor(`${bean.IDDocument} - ${bean.Mnemonic} - ${bean.Consecutive}`);
            onChange(bean)
        } else {
            toast.error("Documento no valido")
        }
    }

    return (
        <>
            <label>{label ?? "Documento Seleccionado"}</label>
            <div className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => setModal({ ...modal, "view": true, "name": "Busqueda de Documento" })}>
                {valor ? (
                    valor
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={getItem}>
                <div className="row">
                    <BasicTable body={lista} head={head} rowSet={setBean} />
                </div>
            </Modal>
        </>
    )
}